<div class="full-slider">
    <img src="assets/images/mrmaid_puttupodi.jpg" alt="">
    <img src="assets/images/mrmaid_puttupodi1.jpg" alt="">
    <img src="assets/images/mrmaid_palappam_podi.jpg" alt="">
    <img src="assets/images/mrmaids_pathiripodi.jpg" alt="">
    <img src="assets/images/mrmaid_puttupodi1.jpg" alt="">
    <img src="assets/images/mrmaid_puttupodi.jpg" alt="">

</div>